import React, { useState, useEffect } from "react";
import { Card, IconButton } from "@material-ui/core";
import { makeStyles } from "@material-ui/core";
import { useAuth } from "../../../contexts/AuthContext";
import { ArrowBack} from "@material-ui/icons";

import UserProfile from "./Profiles/UserProfile";
import EditProfile from "./Profiles/EditProfile";

const useStyles = makeStyles((theme) => ({
  wrapper: {
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "start",
    position: "fixed",
    top: 40,
    width: "400px",
    zIndex: 10,
  },
  card: {
    // height: "100%",
    paddingLeft: theme.spacing(7),
    paddingRight: theme.spacing(7),
    paddingTop: theme.spacing(10),
    paddingBottom: theme.spacing(10),
    backgroundColor: "#f3f5f7",
    borderRadius: theme.spacing(3),
    // minHeight: "85vh",
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(5),
    width: "100%",
    boxShadow: "0 0 6px rgba(0,0,0,0.1)",
    overflowY: "scroll",
    '&::-webkit-scrollbar': {
      display: "none"
    },
  },
  upperDiv: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: theme.spacing(3),
  },
  profilePic: {
    width: theme.spacing(25),
    height: theme.spacing(25),
    marginBottom: theme.spacing(2),
    backgroundColor: "white",
    padding: theme.spacing(4),
    border: "2px solid #f0f0f0",
    boxShadow: "3px 5px 7px rgba(0,0,0,0.5)",
  },
  editButton: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(5),
  },
  back: {
    display: (props) => props.edit? "block" : "none",
  },
}));

export default function ProfileBar() {
  const { currentUser } = useAuth();
  const [quote, setQuote] = useState("");
  const [author, setAuthor] = useState("");
  const [edit,setEdit] = useState(false);
  const classes = useStyles({edit});

  useEffect(() => {
    async function fetchQuote() {
      const quotesJSON = await fetch("https://type.fit/api/quotes");
      const quotes = await quotesJSON.json();
      const date = new Date();
      const dailyRandNum =
        (date.getDay() *
          date.getDate() *
          date.getMonth() *
          date.getFullYear()) %
        quotes.length;
      setQuote(quotes[dailyRandNum].text);
      setAuthor(
        quotes[dailyRandNum].author ? quotes[dailyRandNum].author : "Anonymous"
      );
    }
    fetchQuote();
  }, []);

  return (
    <div className={classes.wrapper}>
      <Card variant="outlined" className={classes.card}>
      <IconButton onClick={() => setEdit(false)} className={classes.back}>
        <ArrowBack />
      </IconButton>
        {!edit && <UserProfile currentUser={currentUser} quote={quote} author={author} setEdit={setEdit} />}
        {edit && <EditProfile currentUser={currentUser} setEdit={setEdit} />}
      </Card>
    </div>
  );
}
